var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.077 17.077 6l.923.923L12.923 12 18 17.077l-.923.923L12 12.923 6.923 18 6 17.077 11.077 12 6 6.923 6.923 6 12 11.077Z",
    id: "CloseIcon_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#CloseIcon_svg__a",
    fillRule: "evenodd"
  })));
};
export default SvgCloseIcon;